import { USER_TRACKING_ID } from '@/constants/localStorage';

export const removeUidFromDataLayer = () => {
  if (typeof window === 'undefined') return;
  const dl = (window.dataLayer as any[]) || [];
  for (let i = dl.length - 1; i >= 0; i--) {
    if (dl[i]?.event === 'user_id') dl.splice(i, 1);
  }
};

export const pushUid = (userId: string) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = (window.dataLayer as any) || [];
  removeUidFromDataLayer();
  window.dataLayer.push({ event: 'user_id', user_id: userId });
};

export const storeAndPushUid = (userId: string) => {
  localStorage.setItem(USER_TRACKING_ID, userId);
  pushUid(userId);
};
